/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ColdStorageResponseDto,
  CreateColdStorageCommandControllerCreate201,
  CreateColdStorageDto,
  ListColdStorageQueryControllerListParams,
  UpdateColdStorageCommandControllerUpdate200,
  UpdateColdStorageDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Create a fridge or freezer for a nursery
 */
export const createColdStorageCommandControllerCreate = (
  nurseryId: string,
  createColdStorageDto: CreateColdStorageDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CreateColdStorageCommandControllerCreate201>({
    url: `/v1/nurseries/${nurseryId}/cold-storage`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createColdStorageDto,
    signal,
  });
};

export const getCreateColdStorageCommandControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createColdStorageCommandControllerCreate>>,
    TError,
    { nurseryId: string; data: CreateColdStorageDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createColdStorageCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateColdStorageDto },
  TContext
> => {
  const mutationKey = ["createColdStorageCommandControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createColdStorageCommandControllerCreate>>,
    { nurseryId: string; data: CreateColdStorageDto }
  > = (props) => {
    const { nurseryId, data } = props ?? {};

    return createColdStorageCommandControllerCreate(nurseryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateColdStorageCommandControllerCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createColdStorageCommandControllerCreate>>
  >;
export type CreateColdStorageCommandControllerCreateMutationBody =
  CreateColdStorageDto;
export type CreateColdStorageCommandControllerCreateMutationError = void;

/**
 * @summary Create a fridge or freezer for a nursery
 */
export const useCreateColdStorageCommandControllerCreate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createColdStorageCommandControllerCreate>>,
      TError,
      { nurseryId: string; data: CreateColdStorageDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createColdStorageCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateColdStorageDto },
  TContext
> => {
  return useMutation(
    getCreateColdStorageCommandControllerCreateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary List all cold-storage units for a nursery
 */
export const listColdStorageQueryControllerList = (
  nurseryId: string,
  params?: ListColdStorageQueryControllerListParams,
  signal?: AbortSignal,
) => {
  return axiosClient<ColdStorageResponseDto[]>({
    url: `/v1/nurseries/${nurseryId}/cold-storage`,
    method: "GET",
    params,
    signal,
  });
};

export const getListColdStorageQueryControllerListQueryKey = (
  nurseryId: string,
  params?: ListColdStorageQueryControllerListParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/cold-storage`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListColdStorageQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listColdStorageQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListColdStorageQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listColdStorageQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListColdStorageQueryControllerListQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listColdStorageQueryControllerList>>
  > = ({ signal }) =>
    listColdStorageQueryControllerList(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listColdStorageQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListColdStorageQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listColdStorageQueryControllerList>>
>;
export type ListColdStorageQueryControllerListQueryError = void;

export function useListColdStorageQueryControllerList<
  TData = Awaited<ReturnType<typeof listColdStorageQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params: undefined | ListColdStorageQueryControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listColdStorageQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listColdStorageQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listColdStorageQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListColdStorageQueryControllerList<
  TData = Awaited<ReturnType<typeof listColdStorageQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListColdStorageQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listColdStorageQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listColdStorageQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listColdStorageQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListColdStorageQueryControllerList<
  TData = Awaited<ReturnType<typeof listColdStorageQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListColdStorageQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listColdStorageQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all cold-storage units for a nursery
 */

export function useListColdStorageQueryControllerList<
  TData = Awaited<ReturnType<typeof listColdStorageQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListColdStorageQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listColdStorageQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListColdStorageQueryControllerListQueryOptions(
    nurseryId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a cold-storage unit
 */
export const updateColdStorageCommandControllerUpdate = (
  nurseryId: string,
  coldStorageId: string,
  updateColdStorageDto: UpdateColdStorageDto,
  signal?: AbortSignal,
) => {
  return axiosClient<UpdateColdStorageCommandControllerUpdate200>({
    url: `/v1/nurseries/${nurseryId}/cold-storage/${coldStorageId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateColdStorageDto,
    signal,
  });
};

export const getUpdateColdStorageCommandControllerUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateColdStorageCommandControllerUpdate>>,
    TError,
    { nurseryId: string; coldStorageId: string; data: UpdateColdStorageDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateColdStorageCommandControllerUpdate>>,
  TError,
  { nurseryId: string; coldStorageId: string; data: UpdateColdStorageDto },
  TContext
> => {
  const mutationKey = ["updateColdStorageCommandControllerUpdate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateColdStorageCommandControllerUpdate>>,
    { nurseryId: string; coldStorageId: string; data: UpdateColdStorageDto }
  > = (props) => {
    const { nurseryId, coldStorageId, data } = props ?? {};

    return updateColdStorageCommandControllerUpdate(
      nurseryId,
      coldStorageId,
      data,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateColdStorageCommandControllerUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateColdStorageCommandControllerUpdate>>
  >;
export type UpdateColdStorageCommandControllerUpdateMutationBody =
  UpdateColdStorageDto;
export type UpdateColdStorageCommandControllerUpdateMutationError = void;

/**
 * @summary Update a cold-storage unit
 */
export const useUpdateColdStorageCommandControllerUpdate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateColdStorageCommandControllerUpdate>>,
      TError,
      { nurseryId: string; coldStorageId: string; data: UpdateColdStorageDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateColdStorageCommandControllerUpdate>>,
  TError,
  { nurseryId: string; coldStorageId: string; data: UpdateColdStorageDto },
  TContext
> => {
  return useMutation(
    getUpdateColdStorageCommandControllerUpdateMutationOptions(options),
    queryClient,
  );
};
